import React from "react";
import { Route } from 'react-router';
import ToolsCountry from './ToolsCountry';
import styled from 'styled-components';

export default function ToolsCountryPage(props) {
    const Margin20 = styled.div`
    margin-top: 20px;
`;
    return (
        <div>
            <style>
                {`body {
                        background: #f1f2f7;
                    }`}
            </style>
            <Margin20 />
            <Route exact path={`${props.match.url}`} component={ToolsCountry} />
        </div>
    )
}
